const BannerTypes = {
    GET_BANNERS: "GET_BANNERS",
    GET_BANNERS_SUCCESS: "GET_BANNERS_SUCCESS",
    GET_BANNER_TAGS: "GET_BANNER_TAGS",
};

export { BannerTypes };
